module.exports = __webpack_public_path__ + "static/media/maklo1.c6617b96.jpg";